export default __webpack_public_path__ + "static/media/herobg.924a5544.jpeg";